export const errorCodes = {
  common: {
    NOT_FOUND: 'not-found',
    VALIDATION_ERROR: 'validation-error'
  },
  auth: {
    PERMISSION_DENIED: 'permission-denied',
    TOKEN_MISSING: 'token-missing',
    TOKEN_EXPIRED: 'token-expired',
    TOKEN_INVALID: 'token-invalid',
    INVALID_USER: 'invalid-user',
    INVALID_ACCOUNT_CONTEXT: 'invalid-account-context',
    PERMISSION_DENIED_INVALID_ACCOUNT_CONTEXT:
      'permission-denied-invalid-account-context'
  },
  account: {
    DUPLICATE_EMAIL: 'account::duplicate-email',
    DUPLICATE_PHONE: 'account::duplicate-phone',
    NOT_ONBOARDED: 'account::not-onboarded',
    ALREADY_ONBOARDED: 'account::already-onboarded',
    DUPLICATE_NAME: 'account::duplicate-name',
    RESTRICTED_NAME: 'account::restricted-name'
  },
  carePlan: {
    CREATE_INVALID_ACCOUNT_ID: 'care-plan::create-invalid-account-id',
    DUPLICATED_CODE: 'care-plan::duplicate-code',
    DELETE_FORBIDDEN: 'care-plan::delete-forbidden'
  },
  contentCategory: {
    DUPLICATE_NAME: 'content-category::duplicate-name'
  },
  contentResource: {
    CREATE_INVALID_ACCOUNT_ID: 'content-resource::create-invalid-account-id',
    CREATE_INVALID_TAGS_ID: 'content-resource::create-invalid-tags-id',
    CREATE_INVALID_PATIENTS_ID: 'content-resource::create-invalid-patients-id',
    CREATE_INVALID_CATEGORY_ID: 'content-resource::create-invalid-category-id',
    UPDATE_CANNOT_BE_PUBLISHED: 'content-resource::update-cannot-be-published'
  },
  contentTags: {
    DUPLICATE_NAME: 'content-tag::duplicate-name',
    CREATE_INVALID_CARE_PLANS_ID: 'content-tag::create-invalid-care-plan-id'
  },
  coupon: {
    CREATE_INVALID_ACCOUNT_ID: 'coupon::create-invalid-account-id',
    CREATE_INVALID_CODE_NOT_UNIQUE: 'coupon::create-invalid-code-not-unique'
  },
  user: {
    DUPLICATE_EMAIL: 'user::duplicate-email',
    DUPLICATE_PHONE: 'user::duplicate-phone',
    INVALID_ACCOUNT: 'user::invalid-account'
  },
  product: {},
  medications: {
    INVALID_MEDICATION_IDS: 'medication::invalid-medication-ids',
    INVALID_DEFAULT_SHIPPING_METHOD_ID:
      'medication::invalid-default-shipping-method-id',
    UPDATE_INVALID_INSTRUCTIONS_QUANTITY_ID:
      'medication::update-invalid-instructions-quantity-id',
    UPDATE_INVALID_INSTRUCTIONS_FREQUENCY_ID:
      'medication::update-invalid-instructions-frequency-id'
  },
  patient: {
    DUPLICATE_EMAIL: 'patient::duplicate-email',
    DUPLICATE_PHONE: 'patient::duplicate-phone',
    INVALID_ACCOUNT: 'patient::invalid-account',
    INVALID_RESPONSIBLE_PROVIDER: 'patient::invalid-provider',
    INVALID_AUTHOR: 'patient::invalid-author'
  },
  invoice: {
    CREATE_INVALID_ACCOUNT_ID: 'invoice::invalid-account-id',
    CREATE_INVALID_PATIENT_ID: 'invoice::invalid-patient-id',
    CREATE_INVALID_PRODUCT_ID: 'invoice::invalid-product-id',
    CREATE_INVALID_SHIPPING_METHOD: 'invoice::invalid-shipping-method',
    UPDATE_INVALID_STATUS: 'invoice::update-invalid-status',
    DELETE_INVALID_STATUS: 'invoice::delete-invalid-status',
    PAY_INVALID_STATUS: 'invoice::pay-invalid-status',
    PAY_INVALID_PAYMENT_METHOD: 'invoice::pay-invalid-payment-method',
    CREATE_INVALID_CARE_PLAN: 'invoice::create-invalid-care-plan',
    VOID_INVALID_STATUS: 'invoice::void-invalid-status',
    REFUND_NOT_PAID: 'invoice::refund-not-paid',
    REFUND_AMOUNT_TOO_BIG: 'invoice::refund-amount-too-big',
    FULFILL_INVALID_STATUS: 'invoice::fulfill-invalid-status',
    FULFILL_ALREADY_FULFILLED: 'invoice::fulfill-already-fulfilled',
    CREATE_PATIENT_NOT_ONBOARDED: 'invoice::create-patient-not-onboarded',
    CREATE_ACCOUNT_NOT_ONBOARDED: 'invoice::create-account-not-onboarded'
  },
  order: {
    CREATE_INVALID_PATIENT_ID: 'order::create-invalid-patient-id',
    CREATE_INVALID_ACCOUNT_ID: 'order::create-invalid-account-id',
    CREATE_INVALID_PRODUCT_ID: 'order::create-invalid-product-id',
    CREATE_INVALID_SHIPPING_METHOD: 'order::create-invalid-shipping-method',
    CREATE_MISSING_SHIPPING_ADDRESS: 'order::create-missing-shipping-address',
    CREATE_INVALID_INVOICE_ID: 'order::create-invalid-invoice-id',
    FINALIZE_INVALID_STATUS: 'order::finalize-invalid-status',
    DELETE_INVALID_STATUS: 'order::delete-invalid-status',
    CANCEL_INVALID_STATUS: 'order::cancel-invalid-status',
    CREATE_NOTE_INVALID_ORDER_STATUS: 'order::create-note-invalid-order-status'
  },
  paymentMethod: {
    ADD_PAYMENT_STRIPE_ERROR: 'payment-method::add-payment-stripe-error'
  },
  subscription: {
    CREATE_INVALID_PATIENT_ID: 'subscription::create-invalid-patient-id',
    CREATE_INVALID_ACCOUNT_ID: 'subscription::create-invalid-account-id',
    CREATE_INVALID_PRODUCT_ID: 'subscription::create-invalid-product-id',
    CREATE_INVALID_CARE_PLAN: 'subscription::create-invalid-care-plan',
    CREATE_ACCOUNT_NOT_ONBOARDED: 'subscription::create-account-not-onboarded',
    CREATE_PATIENT_NOT_ONBOARDED: 'subscription::create-patient-not-onboarded',
    CREATE_INVALID_COUPON_ID: 'subscription::create-invalid-coupon-id',
    CREATE_INACTIVE_COUPON: 'subscription::create-inactive-coupon',
    CREATE_COUPON_NOT_APPLICABLE:
      'subscription::create-coupon-not-applicationable',
    CREATE_COUPON_AMOUNT_OFF_TOO_BIG:
      'subscription::create-coupon-amount-off-too-big',
    CREATE_PATIENT_ALREADY_HAS_CARE_PLAN:
      'subscription::create-patient-already-has-care-plan',
    CREATE_COUPON_SUBSCRIPTION_VERSION_MISSMATCH:
      'subscription::create-coupon-subscription-version-mismatch',
    CREATE_INVALID_INSTRUCTIONS_QUANTITY_ID:
      'subscription::create-invalid-instructions-quantity-id',
    CREATE_INVALID_INSTRUCTIONS_FREQUENCY_ID:
      'subscription::create-invalid-instructions-frequency-id',
    CREATE_ITEM_INVALID_PRODUCT_ID:
      'subscription::create-item-invalid-product-id',
    INVALID_SHIPPING_METHOD: 'subscription::invalid-shipping-method',

    UPDATE_INVALID_INSTRUCTIONS_QUANTITY_ID:
      'subscription::update-invalid-instructions-quantity-id',
    UPDATE_INVALID_INSTRUCTIONS_FREQUENCY_ID:
      'subscription::update-invalid-instructions-frequency-id',
    UPDATE_INVALID_STATUS: 'subscription::update-invalid-status',
    UPDATE_INVALID_PRODUCT_ID: 'subscription::update-invalid-product-id',
    UPDATE_INVALID_ITEM_ID: 'subscription::update-invalid-item-id',
    UPDATE_ITEM_INVALID_PRODUCT_ID:
      'subscription::update-item-invalid-product-id',
    UPDATE_ITEM_CANCELED: 'subscription::update-item-canceled',

    CANCEL_INVALID_STATUS: 'subscription::cancel-invalid-status',
    CANCEL_ITEM_CANCELED: 'subscription::cancel-item-canceled',

    START_TERMINAL_STATUS: 'subscription::start-terminal-status',
    START_INVALID_STATUS: 'subscription::start-invalid-status',

    ADVANCE_INVALID_STATUS: 'subscription::advance-invalid-status',
    ADVANCE_NO_ITEMS_SELECTED: 'subscription::advance-no-items-selected',
    ADVANCE_TERMINAL_STATUS: 'subscription::advance-terminal-status',
    ADVANCE_LOCKED_ALREADY_ADVANCED:
      'subscription::advance-locked-already-advanced',

    REQUEST_RENEWAL_INVALID_STATUS:
      'subscription::request-renewal-invalid-status',
    REQUEST_RENEWAL_INVALID_ITEMS: 'subscription::request-renewal-invalid-items'
  },
  terminal: {
    READER_OFFLINE: 'terminal::read-offline'
  }
};

export const errorMessageMapper: Record<string, string> = {
  [errorCodes.terminal.READER_OFFLINE]:
    'Reader is currently offline, please ensure the reader is powered on and connected to the internet before retrying your request.'
};
